import { toggleIsLoading } from './loading'
import messageActions from './message'
import modalActions from './modal';
import locationActions from './location'
import vendorConstants from '../constants/vendor';
import vendorService from '../services/vendor';
import tokenHelpers from '../helpers/token';
import refreshHelpers from '../helpers/Refresh';

const vendorList = (data) => ({ type: vendorConstants.LIST_VENDOR, data })
const vendorRetrieve = (detail) => ({ type: vendorConstants.RETRIEVE_VENDOR, data })
const vendorCreate = (detail) => ({ type: vendorConstants.CREATE_VENDOR, detail })
const vendorUpdate = (detail) => ({ type: vendorConstants.UPDATE_VENDOR, detail })
const vendorSelect = (selected) => ({ type: vendorConstants.SELECT_VENDOR, selected })

const vendorActions = {}

vendorActions.list = (path=false) => {
  return (dispatch) => {
    dispatch(toggleIsLoading(true));
    vendorService.list()
    .then((response) => {
      dispatch(vendorList(response));
      let selectedToken = tokenHelpers.getCompanyToken();
      if (response[0] && !selectedToken) dispatch(vendorActions.selectCompany(response[0], path));
      else if (response[0] && selectedToken) {
        let index = 0;
        for (let com of response) {
          if (com.apikey === selectedToken) {
            dispatch(vendorActions.selectCompany(com, path))
            break;
          }
          index+=1;
        }
      }
      dispatch(toggleIsLoading(false));
    })
    .catch((err) => {
      dispatch(toggleIsLoading(false));
      dispatch(messageActions.setErrorMessage(err.message));
    })
  }
}

vendorActions.create = (body) => {
  return (dispatch) => {
    dispatch(toggleIsLoading(true));
    vendorService.create(body)
    .then((response) => {
      dispatch(vendorActions.list());
      dispatch(modalActions.modalToggle(false));
      dispatch(vendorCreate(response));
      dispatch(toggleIsLoading(false));
    })
    .catch((err) => {
      console.log(err);
      dispatch(toggleIsLoading(false));
      dispatch(messageActions.setErrorMessage(err.message));
    })
  }
}

vendorActions.update = (body, vendorApiKey) => {
  return (dispatch) => {
    dispatch(toggleIsLoading(true));
    vendorService.update(body, vendorApiKey)
    .then((response) => {
      dispatch(vendorActions.list());
      dispatch(modalActions.modalToggle(false));
      dispatch(vendorUpdate(response));
      dispatch(toggleIsLoading(false));
    })
    .catch((err) => {
      dispatch(toggleIsLoading(false));
      dispatch(messageActions.setErrorMessage(err.message));
    })
  }
}

vendorActions.selectCompany = (company, path=false) => {
  return (dispatch, getState) => {
    dispatch(vendorSelect(company));
    localStorage.setItem('company_api_key', company.apikey)
    dispatch(locationActions.list(company.apikey, path));
    let locationToken = tokenHelpers.getLocationToken();
    if (path && locationToken) {
      refreshHelpers.refetchPath(
        dispatch, path,
        getState().vendor.selected.apikey,
        locationToken
      );
    }
  }
}


export default vendorActions;



/** WEBPACK FOOTER **
 ** ./src/actions/vendor.js
 **/